require('./bootstrap')
require('./menu')
require('./alerts')
require('./starter-plugins')
require('./observer')

require('./general_functions')
$(".chosen-select").chosen();
let card = require("card");
require('./admin/getStatus')
require('./admin/users')
require('./admin/roles')
require('./admin/permisos')
require('./admin/authors/autocomplete')
require('./admin/authors/authors')
require('./admin/books/books')
require('./admin/books/quotes')
require('./admin/books/search')
require('./admin/sections/sections')
require('./admin/sections/detail')
require('./admin/sections/search')
require('./admin/sections/sort')
require('./admin/slider/sliders')
require('./admin/slider/sort')
require('./admin/billboard/billboard')
require('./admin/billboard/sort')
require('./admin/shipping-cost/shipping-cost')
require('./admin/shipping-cost/shipping-cost-detail')
require('./admin/coupons')
require('./admin/book-coupons')
require('./admin/customers')
require('./admin/orders')
require('./admin/discounts/general')
require('./admin/automcomplete_book')
require('./admin/discounts/individual')
require('./admin/discounts/by-lots')
require('./admin/upload')
require('./admin/pages-authors/pages')
require('./admin/pages-authors/pages-sections')
require('./admin/books/reviews')
require('./admin/gift')

//pdv
require('./admin/punto_venta/autocomplete')
require('./admin/punto_venta/items')

//Almadia
require('./almadia/authors')
require('./almadia/cookies')
require('./almadia/general')
require('./almadia/suscribe')
require('./almadia/billboard')
require('./almadia/cart/cart')
require('./almadia/cart/update_items')
require('./almadia/cart/address')
require('./almadia/cart/billing')
/*require('./almadia/steps/wizard-steps')
require('./almadia/steps/steps')*/
require('./almadia/payment')
require('./almadia/login')
require('./almadia/register')
require('./almadia/wish_list')
require('./almadia/cart/delete_item_zip_code_coupon')
require('./scan')


require('./admin/postulaciones')

